/* eslint-disable */
import {
  SelfServiceVirtualAssessmentExperimentGroup,
  selfServiceVirtualAssessmentExperimentGroupFromJSON,
  selfServiceVirtualAssessmentExperimentGroupToJSON,
} from "../../common/common";

export const protobufPackage = "od_protos.sell.reception.data";

/**
 * Attributes contains additional information on top of a SellerInput,
 * intended for feature flagging. Similar to SellerDetails.
 *
 * Next ID: 6
 */
export interface Attributes {
  /**
   * True if should bypass pause on acquisitions due to COVID-19
   *
   * @deprecated
   */
  covid19Whitelist: boolean;
  /** True if the MtM (Monitor the Market) dashboard has been visited */
  mtmVisited: boolean;
  /**
   * Result of experiments:
   * https://app.optimizely.com/v2/projects/15794150625/features/18945082228/rules
   * https://app.optimizely.com/v2/projects/15794150625/features/18912521268/rules
   */
  selfServiceVirtualAssessmentGroup: SelfServiceVirtualAssessmentExperimentGroup;
  experimentsMap: { [key: string]: string };
  /** Whether the address has a completed assessment (via Abra) within the valid window. */
  hasValidAssessment: boolean;
}

export interface Attributes_ExperimentsMapEntry {
  key: string;
  value: string;
}

function createBaseAttributes(): Attributes {
  return {
    covid19Whitelist: false,
    mtmVisited: false,
    selfServiceVirtualAssessmentGroup: 0,
    experimentsMap: {},
    hasValidAssessment: false,
  };
}

export const Attributes = {
  fromJSON(object: any): Attributes {
    return {
      covid19Whitelist: isSet(object.covid19_whitelist) ? Boolean(object.covid19_whitelist) : false,
      mtmVisited: isSet(object.mtm_visited) ? Boolean(object.mtm_visited) : false,
      selfServiceVirtualAssessmentGroup: isSet(object.self_service_virtual_assessment_group)
        ? selfServiceVirtualAssessmentExperimentGroupFromJSON(object.self_service_virtual_assessment_group)
        : 0,
      experimentsMap: isObject(object.experiments_map)
        ? Object.entries(object.experiments_map).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      hasValidAssessment: isSet(object.has_valid_assessment) ? Boolean(object.has_valid_assessment) : false,
    };
  },

  toJSON(message: Attributes): unknown {
    const obj: any = {};
    if (message.covid19Whitelist === true) {
      obj.covid19_whitelist = message.covid19Whitelist;
    }
    if (message.mtmVisited === true) {
      obj.mtm_visited = message.mtmVisited;
    }
    if (message.selfServiceVirtualAssessmentGroup !== 0) {
      obj.self_service_virtual_assessment_group = selfServiceVirtualAssessmentExperimentGroupToJSON(
        message.selfServiceVirtualAssessmentGroup,
      );
    }
    if (message.experimentsMap) {
      const entries = Object.entries(message.experimentsMap);
      if (entries.length > 0) {
        obj.experiments_map = {};
        entries.forEach(([k, v]) => {
          obj.experiments_map[k] = v;
        });
      }
    }
    if (message.hasValidAssessment === true) {
      obj.has_valid_assessment = message.hasValidAssessment;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Attributes>, I>>(base?: I): Attributes {
    return Attributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Attributes>, I>>(object: I): Attributes {
    const message = createBaseAttributes();
    message.covid19Whitelist = object.covid19Whitelist ?? false;
    message.mtmVisited = object.mtmVisited ?? false;
    message.selfServiceVirtualAssessmentGroup = object.selfServiceVirtualAssessmentGroup ?? 0;
    message.experimentsMap = Object.entries(object.experimentsMap ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = String(value);
        }
        return acc;
      },
      {},
    );
    message.hasValidAssessment = object.hasValidAssessment ?? false;
    return message;
  },
};

function createBaseAttributes_ExperimentsMapEntry(): Attributes_ExperimentsMapEntry {
  return { key: "", value: "" };
}

export const Attributes_ExperimentsMapEntry = {
  fromJSON(object: any): Attributes_ExperimentsMapEntry {
    return { key: isSet(object.key) ? String(object.key) : "", value: isSet(object.value) ? String(object.value) : "" };
  },

  toJSON(message: Attributes_ExperimentsMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Attributes_ExperimentsMapEntry>, I>>(base?: I): Attributes_ExperimentsMapEntry {
    return Attributes_ExperimentsMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Attributes_ExperimentsMapEntry>, I>>(
    object: I,
  ): Attributes_ExperimentsMapEntry {
    const message = createBaseAttributes_ExperimentsMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
